import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PassphraseLoginComponent } from '@common-standalone/2fa/passphrase-login/passphrase-login.component';
import { ResetPasspharseComponent } from '@common-standalone/2fa/reset-passpharse/reset-passpharse.component';



@NgModule({
  imports: [
    CommonModule,
    PassphraseLoginComponent,
    ResetPasspharseComponent
  ],
  exports:[
    PassphraseLoginComponent,
    ResetPasspharseComponent
  ]
})
export class TwoFaModule { }
